import { ICONS, PACKAGE_ICON } from "@/lib/icons";
import { SmartImg } from "./SmartImg";

// Placeholder pakietu (fallback) LUB dostarczona grafika 4:3 (imageSrc, status CANDIDATE).
// Grafiki: object-fit cover, bez filtrów i ręcznego kadrowania. Nazwa/opis pozostają w HTML.
export const PackagePlaceholder = ({ packageId, name, imageSrc = null }) => {
  const Icon = ICONS[PACKAGE_ICON[packageId]] || ICONS.full;

  if (imageSrc) {
    const src = imageSrc.startsWith("http") || imageSrc.startsWith("/") ? imageSrc : `/${imageSrc}`;
    return (
      <div className="relative aspect-[4/3] w-full overflow-hidden rounded-t-card bg-brand-elevated">
        <SmartImg
          src={src}
          alt={name}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          data-testid={`package-image-${packageId}`}
        />
      </div>
    );
  }

  return (
    <div
      className="relative flex aspect-[4/3] w-full flex-col items-center justify-center overflow-hidden rounded-t-card bg-[linear-gradient(140deg,#141714,#0D0F0E)]"
      data-testid={`package-placeholder-${packageId}`}
      data-placeholder-status="PLACEHOLDER_REQUIRED"
    >
      <span className="absolute inset-0 opacity-[0.06] [background-image:radial-gradient(circle_at_1px_1px,#B6FF00_1px,transparent_0)] [background-size:12px_12px]" />
      <span className="absolute left-3 top-3 rounded-full border border-brand-line bg-brand-bg/70 px-2 py-0.5 text-[10px] font-medium tracking-wide text-brand-muted">
        Grafika wkrótce
      </span>
      <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-field border border-brand-line bg-brand-bg/50 text-brand-accent">
        <Icon size={26} strokeWidth={1.75} aria-hidden="true" />
      </span>
      <span className="max-w-[80%] text-center font-display text-xs font-medium text-brand-sec">{name}</span>
    </div>
  );
};
